import { render, staticRenderFns } from "./ep_date.vue?vue&type=template&id=1a5106a0&scoped=true"
import script from "./ep_date.vue?vue&type=script&lang=js"
export * from "./ep_date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5106a0",
  null
  
)

export default component.exports